import React from 'react';

import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';

import { DriverLicense } from '../DriverLicense/DriverLicense';
import { Passport } from '../Passport/Passport';
import { PersonalData } from '../PersonalData/PersonalData';

import { useFormPresenter } from './Form.presenter';
import * as S from './Form.styles';

export const Form = ({ header, isOwnerForm, title }) => {
  const presenter = useFormPresenter({ isOwnerForm });

  return (
    <PageContent
      title={title}
      header={
        <S.Header>
          <S.Checkbox
            disabled={presenter.disabled}
            value={presenter.isDriver}
            onChange={presenter.onChangeIsDriver}
          >
            Водитель
          </S.Checkbox>
          {header}
        </S.Header>
      }
    >
      <PersonalData isOwnerForm={isOwnerForm} />
      <Passport isOwnerForm={isOwnerForm} />
      {presenter.isDriver && <DriverLicense isOwnerForm={isOwnerForm} />}
    </PageContent>
  );
};
